import "@/App.css";
import HumanDataCashCup from "./pages/HumanDataCashCup";

function App() {
  return (
    <div className="App">
      <HumanDataCashCup />
    </div>
  );
}

export default App;
